// extracted by mini-css-extract-plugin
export default {"ngmUIHorizontalLine":"horizontalLine_ngmUIHorizontalLine__lgzXP"};